import { render } from "./SendTestV4Preview.vue?vue&type=template&id=2ff82312&scoped=true"
import script from "./SendTestV4Preview.vue?vue&type=script&lang=ts"
export * from "./SendTestV4Preview.vue?vue&type=script&lang=ts"

import "./SendTestV4Preview.vue?vue&type=style&index=0&id=2ff82312&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ff82312"

export default script